<template>
	<div
		class="col carousel__item carousel__item_alt js-carousel__item"
		:class="displayWithLink ? '' : 'no-link'"
		:id="'card-' + id"
	>
		<component
			:is="tagType"
			class="card card--with-image card--dark"
			:href="displayWithLink ? link : ''"
		>
			<div
				v-if="!showSimpleView && responsiveImageThreeColumns"
				class="hotspot-list__image card__image"
				v-html="responsiveImageThreeColumns"
			></div>
			<div
				v-else-if="!showSimpleView"
				class="hotspot-list__image card__image"
				v-html="LeafPatternLarge"
			></div>

			<span class="card__icon color-schwarzgrau" v-html="IconCalendar">
			</span>

			<div class="hotspot-list__container">
				<p
					class="hotspot-list__date color-placeholder"
					:aria-describedby="id"
				>
					<template v-for="(tag, key) in tags">
						{{ tag + (key < tags.length - 1 ? " | " : "") }}
					</template>
				</p>
				<h3
					:id="id"
					class="body-text--small bold card__title hotspot-list__headline"
				>
					{{ title }}
				</h3>
				<div class="grid">
					<div class="col-6">
						<p
							class="facetted-list-item__label color-placeholder"
							:aria-describedby="'facetted-list-title__' + id"
						>
							{{ labelDate }}
						</p>
						<p
							class="facetted-list-item__value"
							:aria-describedby="'facetted-list-title__' + id"
						>
							{{ dateString }}
							<template v-if="endDateString != ''">
								&nbsp;-
								<br />
								{{ endDateString }}
							</template>
						</p>
					</div>
					<div class="col-6">
						<p
							class="facetted-list-item__label color-placeholder"
							:aria-describedby="'facetted-list-title__' + id"
						>
							{{ labelPlace }}
						</p>
						<p
							class="facetted-list-item__value"
							:aria-describedby="'facetted-list-title__' + id"
						>
							<span
								:aria-label="place ? '' : ariaLabelEmptyField"
								>{{ place ? place : "-" }}</span
							>
						</p>
					</div>
					<div class="col-6">
						<p
							class="facetted-list-item__label color-placeholder"
							:aria-describedby="'facetted-list-title__' + id"
						>
							{{ labelTime }}
						</p>
						<p
							class="facetted-list-item__value"
							:aria-describedby="'facetted-list-title__' + id"
						>
							<span :aria-label="ariaLabelEmptyField">{{
								timeString ? timeString : "-"
							}}</span>
						</p>
					</div>
					<div class="col-6">
						<p
							class="facetted-list-item__label color-placeholder"
							:aria-describedby="'facetted-list-title__' + id"
						>
							{{ labelPrice }}
						</p>
						<p
							class="facetted-list-item__value"
							:aria-describedby="'facetted-list-title__' + id"
						>
							<span
								:aria-label="price ? '' : ariaLabelEmptyField"
								>{{ price ? price : "-" }}</span
							>
						</p>
					</div>
				</div>
			</div>
		</component>
	</div>
</template>

<script setup>
import { computed } from "vue";
import IconCalendar from "../../../views/icons/calendar.cshtml";
import LeafPatternLarge from "../../../views/visuals/leafPatternLarge.cshtml";
import { defineProps } from "vue";

const props = defineProps({
	id: {
		type: String,
		default: "",
	},
	title: {
		type: String,
		default: "",
	},
	responsiveImageThreeColumns: {
		type: String,
		default: "",
	},
	link: {
		type: String,
		default: "",
	},
	manchet: {
		type: String,
		default: "",
	},
	dateText: {
		type: String,
		default: "",
	},
	dateString: {
		type: String,
		default: "",
	},
	endDateString: {
		type: String,
		default: "",
	},
	place: {
		type: String,
		default: "",
	},
	price: {
		type: String,
		default: "",
	},
	timeString: {
		type: String,
		default: "",
	},
	disableLink: {
		type: Boolean,
		default: false,
	},
	showSimpleView: {
		type: Boolean,
		default: false,
	},
	tags: {
		type: Array,
		default: () => [],
	},
	labelTime: {
		type: String,
		default: "",
	},
	labelDate: {
		type: String,
		default: "",
	},
	labelPrice: {
		type: String,
		default: "",
	},
	labelPlace: {
		type: String,
		default: "",
	},
	ariaLabelEmptyField: {
		type: String,
		default: "",
	},
});

const displayWithLink = computed(() => {
	return props.link && !props.disableLink;
});

const tagType = computed(() => {
	return displayWithLink ? "a" : "div";
});
</script>
